import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { from, Observable, of } from 'rxjs';
import { PagePermissionsService } from './page-permissions.service';
import { AccountService } from './account.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RoutePermissionGuard implements CanActivate {

  constructor(
    private pagePermissions: PagePermissionsService,
    private accountService : AccountService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const requiredPermissions = this.getRequiredPermissions(route);

    if (!requiredPermissions || requiredPermissions.length === 0) {
      return of(true);
    }

    return from(this.accountService.identity()).pipe(
      map(user => {
        if (!user) {
          this.router.navigate(['/']);
          return false;
        }
        const hasPermission = requiredPermissions.some(permission => {
          const [page, action] = permission.split(".");
          return this.pagePermissions.hasPagePermission(page, action, true);
        });

        if (!hasPermission) {
          this.router.navigate(['/h/error/403'], {
            queryParams: {
              attempted: state.url 
            }
          });
          return false;
        }
        return true;
      })
    )
  }

  private getRequiredPermissions(route: ActivatedRouteSnapshot): string[]{
    let currentRoute: ActivatedRouteSnapshot | null = route;
    while(currentRoute){
      const permissions = currentRoute.data['requiredPermissions'] as string[];
      if(permissions && permissions.length > 0){
        return permissions;
      }
      currentRoute = currentRoute.parent
    }
    return [];
  }
}

